import styles from 'components/Shared/Layout/styles.scss';
import cn from 'classnames';
import { AppearanceTypes, Base, BaseProps } from 'components/Shared/Layout/base';

export type SectionsProps = BaseProps<AppearanceTypes>;

export const Sections = ({ children, className, ...base }: SectionsProps) => (
  <Base {...base} className={cn(styles.sections, className)}>
    {children}
  </Base>
);
